module.exports = __webpack_public_path__ + "assets/076adb076b391a86ccdd8afae3b02b50.png";